import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "expand",
  "use": "expand-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"expand\"><path fill-rule=\"evenodd\" d=\"m5 17.59 4.5-4.5 1.41 1.41-4.5 4.5H10v2H3v-7h2v3.59ZM14 3h7v7h-2V6.41l-4.5 4.5-1.41-1.41 4.5-4.5H14V3Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol